import React, { useState } from 'react';
import { Vendor, VendorTrackingDetails } from '../services/vendor/types';
import { useVendorService } from '../services/vendor';
import { StoreCard } from './index';

const PAGE_SIZE = 12;

interface Props {
    stores: Vendor[];
}

const StoreGrid = ({ stores }: Props) => {
    const [page, setPage] = useState(0);
    const [activatedVendors, setActivatedVendors] = useState<Map<string, VendorTrackingDetails>>(new Map());
    const service = useVendorService();

    const totalPages = Math.ceil(stores.length / PAGE_SIZE);
    const paginated = stores.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

    const activateVendor = (campaignId: string) => {
        return service.activateVendor({ campaignId, source: 'WEB_DESKTOP' }).then(response => {
            setActivatedVendors(prev => {
                const next = new Map(prev);
                return next.set(campaignId, response);
            });
            return response;
        });
    };

    return (
        <>
            <div className="store-grid">
                {paginated.map((store, i) => (
                    <StoreCard
                        key={page * PAGE_SIZE + i}
                        store={store}
                        index={i}
                        trackingDetails={activatedVendors.get(store.id)!}
                        activateVendor={activateVendor}
                    />
                ))}
            </div>

            {totalPages > 1 && (
                <div className="store-pagination">
                    <button
                        className="tx-page-btn"
                        onClick={() => { setPage(p => p - 1); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                        disabled={page === 0}
                    >
                        ←
                    </button>
                    <span className="tx-page-label">{page + 1} / {totalPages}</span>
                    <button
                        className="tx-page-btn"
                        onClick={() => { setPage(p => p + 1); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                        disabled={page === totalPages - 1}
                    >
                        →
                    </button>
                </div>
            )}
        </>
    );
};

export default StoreGrid;